import React, { Component, Suspense } from 'react';

import eureka from 'eureka';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Header, SidePanel } from '../common';
import { ShellDialog } from '../plugins/dialog.plugin';
import MessageToast from '../plugins/toast.plugin';
import Tiles from './Tiles';
import * as actions from './redux/actions';

const { Spinner } = eureka.components;
const { withTranslation } = eureka.I18nProvider;
const { OptionalMessageBox } = eureka.controls;
export class WelcomePage extends Component {
  static propTypes = {
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    settings: PropTypes.object.isRequired,
    eventBus: PropTypes.object.isRequired,
  };

  componentDidMount() {
    if (
      this.props.config &&
      (this.props.config.components || []).filter(
        (c) => c.name === 'analytics-dashboard-ui',
      ).length > 0
    ) {
      this.props.history.push('/analytics-dashboard');
    }
  }

  render() {
    const { showMenu } = this.props.common;
    // const { t } = this.props;

    return (
      <div id="eureka-shell-container" className="fd-shell fd-shell--fundamentals">
        <div className="shell-header">
          <Suspense fallback={<Spinner />}>
            <Header
              history={this.props.history}
              config={this.props.config}
              settings={this.props.settings}
              eventBus={this.props.eventBus}
              user={this.props.user}
            />
          </Suspense>
        </div>
        <div className="fd-shell__app">
          <div className="fd-app">
            <div
              className={`fd-app__navigation fd-app__navigation--vertical${
                showMenu ? ' show-menu' : ' hide-menu'
              }`}
            >
              <Suspense fallback={<Spinner />}>
                <SidePanel
                  history={this.props.history}
                  match={this.props.match}
                  config={this.props.config}
                />
              </Suspense>
            </div>
            <main className="fd-app__main">
              <Suspense fallback={<Spinner cssClass="page-load-spinner" />}>
                <div className="home-page">
                  <Tiles history={this.props.history} config={this.props.config} />
                </div>
              </Suspense>
            </main>
          </div>
        </div>
        <ShellDialog key="welcome-page-dialog" />
        <MessageToast key="welcome-page-toast" />
        <OptionalMessageBox />
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(WelcomePage));
